export const customGeopointBasicTypes = {
  store: 'icon-store',
  bank: 'icon-bank',
  parking: 'icon-parking',
  food: 'icon-food',
  cinema: 'icon-cinema',
  toilet: 'icon-toilet',
  park: 'icon-park',
  medical: 'icon-medical',
  bar: 'icon-bar',
  'fuel-station': 'icon-fuel-station',
  hotel: 'icon-hotel',
  'parking-bonus': 'icon-parking-bonus',
};

export const customGeopointProhibitionTypes = {
  'riding-prohibited': 'icon-riding-prohibited',
  'scooter-riding-prohibited': 'icon-scooter-riding-prohibited',
  'bicycle-riding-prohibited': 'icon-bicycle-riding-prohibited',
  'no-parking': 'icon-no-parking',
  'speed-limit-5': 'icon-speed-limit-5',
  'speed-limit-10': 'icon-speed-limit-10',
  'speed-limit-15': 'icon-speed-limit-15',
  'speed-limit-20': 'icon-speed-limit-20',
};

export const customGeopointType = {...customGeopointBasicTypes, ...customGeopointProhibitionTypes};
